import React, { useCallback, useState, Children, cloneElement } from 'react'
import { classNames } from '@zambezi/sdk/common'
import SelectableCell from './SelectableCell'

/**
 * Create a React Table Row component
 *
 * @param {import('./interfaces').TableRowProps} props
 * @returns {JSX.Element}
 */
export default function TableRow ({ children, rowIndex, rowProps, isSelected }) {
  const [open, setOpen] = useState(false)
  const onToggleClick = useCallback(open => setOpen(!open), [setOpen])

  return (
    <tr
      aria-rowindex={rowIndex}
      aria-selected={isSelected}
      {...rowProps}
      className={
        classNames(rowProps.className, {
          'zb-table-accordion-open': open
        }) || null
      }
    >
      {Children.map(children, childMap)}
    </tr>
  )

  /**
   * @param {import('react').ReactElement} child
   * @returns {JSX.Element}
   */
  function childMap (child) {
    // Add click handler and open state to SelectableCells to keep the state in the row
    return child && child.type === SelectableCell
      ? cloneElement(child, { onToggleClick, open })
      : child
  }
}
